import type { Action } from "../../actions/types";

interface Coupon {
  id: string;
  status: string;
}

interface CouponBank {
  amount: number;
  currency: string;
}

interface Reward {
  amount?: number;
  currency?: string;
  rewardType?: string;
}

interface Transaction {
  exchangerName?: string;
}

export interface RewardRecord {
  id: string;
  coupon: Coupon;
  couponBank: CouponBank;
  createdOn: string;
  earningEventName?: string;
  reward?: Reward;
  transaction?: Transaction;
  status?: string;
  redemptionInfo?: any;
  definition?: RewardDefinition;
}

interface RewardDefinition {
  id?: string | number;
  name?: string;
  value?: string;
  code?: string;
}

export type StoreState = RewardRecord[];

export const initialState = [];

export function reducer(
  state: StoreState | null = initialState,
  action: Action
): StoreState | null {
  if (action.type === "GET_REWARDS_SUCCESS") {
    return action.response.data.rewards;
  }

  return state;
}
